import { ModelCreatePage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$owner/players/new')({
  validateSearch: (search: Record<string, unknown>): { parentId: number } => {
    return {
      parentId: Number(search?.parentId)
    };
  },
  component: RouteComponent
});

function RouteComponent() {
  const { parentId } = Route.useSearch();

  return <ModelCreatePage model="player" parentId={parentId} />;
}
